import loadable from '@loadable/component';

/* eslint react-app/import/no-webpack-loader-syntax: off */
const ARROW_RIGHT = loadable(() => import('-!svg-react-loader!@assets/images/arrow-right.svg'));
const CHEVRON_RIGHT = loadable(() => import('-!svg-react-loader!@assets/images/chevron-right.svg'));
const CLOSE = loadable(() => import('-!svg-react-loader!@assets/images/close.svg'));
const CLOSE_SMALL = loadable(() => import('-!svg-react-loader!@assets/images/close-small.svg'));
const CONTACT = loadable(() => import('-!svg-react-loader!@assets/images/contact.svg'));
const ELLIPSE = loadable(() => import('-!svg-react-loader!@assets/images/ellipse.svg'));
const EXTERNAL_LINK = loadable(() => import('-!svg-react-loader!@assets/images/external-link.svg'));
const EXTERNAL_LINK_LARGE = loadable(() => import('-!svg-react-loader!@assets/images/external-link-large.svg'));
const EXTERNAL_LINK_BLUE = loadable(() => import('-!svg-react-loader!@assets/images/external-link-blue.svg'));
const EXTERNAL_LINK_PINK = loadable(() => import('-!svg-react-loader!@assets/images/external-link-pink.svg'));
const FACEBOOK = loadable(() => import('-!svg-react-loader!@assets/images/facebook.svg'));
const FOOTER_LOGO = loadable(() => import('-!svg-react-loader!@assets/images/footer-logo.svg'));
const FILTER = loadable(() => import('-!svg-react-loader!@assets/images/filter.svg'));
const INFO = loadable(() => import('-!svg-react-loader!@assets/images/info.svg'));
const INFO_BLUE = loadable(() => import('-!svg-react-loader!@assets/images/info-blue.svg'));
const INFO_FILL = loadable(() => import('-!svg-react-loader!@assets/images/info-fill.svg'));
const INSTAGRAM = loadable(() => import('-!svg-react-loader!@assets/images/instagram.svg'));
const LINKEDIN = loadable(() => import('-!svg-react-loader!@assets/images/linkedin.svg'));
const LIST = loadable(() => import('-!svg-react-loader!@assets/images/list.svg'));
const LIST_ALT = loadable(() => import('-!svg-react-loader!@assets/images/list-alt.svg'));
const LIST_BLUE = loadable(() => import('-!svg-react-loader!@assets/images/list-blue.svg'));
const LOGO = loadable(() => import('-!svg-react-loader!@assets/images/logo.svg'));
const MENU = loadable(() => import('-!svg-react-loader!@assets/images/menu.svg'));
const PHONE = loadable(() => import('-!svg-react-loader!@assets/images/phone.svg'));
const QUESTION_MARK = loadable(() => import('-!svg-react-loader!@assets/images/question-mark.svg'));
const SEARCH = loadable(() => import('-!svg-react-loader!@assets/images/search.svg'));
const DOCUMENT = loadable(() => import('-!svg-react-loader!@assets/images/document.svg'));
const SHARE = loadable(() => import('-!svg-react-loader!@assets/images/share.svg'));
const CHECK = loadable(() => import('-!svg-react-loader!@assets/images/check.svg'));
const PARTICLES = loadable(() => import('-!svg-react-loader!@assets/images/particles.svg'));
const THEMES = loadable(() => import('-!svg-react-loader!@assets/images/themes.svg'));
const TWITTER = loadable(() => import('-!svg-react-loader!@assets/images/twitter.svg'));

export const VISUALS = {
  ARROW_RIGHT,
  CHEVRON_RIGHT,
  CLOSE,
  CLOSE_SMALL,
  CONTACT,
  DOCUMENT,
  ELLIPSE,
  EXTERNAL_LINK,
  EXTERNAL_LINK_LARGE,
  EXTERNAL_LINK_BLUE,
  EXTERNAL_LINK_PINK,
  FACEBOOK,
  FILTER,
  INFO,
  INFO_BLUE,
  INFO_FILL,
  INSTAGRAM,
  LINKEDIN,
  LIST,
  LIST_ALT,
  LIST_BLUE,
  LOGO,
  MENU,
  PHONE,
  QUESTION_MARK,
  SEARCH,
  SHARE,
  CHECK,
  PARTICLES,
  THEMES,
  TWITTER,
  FOOTER_LOGO,
};

export default {};
